import { useAtom } from 'jotai';
import { useChatClient } from '@bizzabo/chat-core';
import ChatMessageDialog from '../CustomMessage/ChatMessageDialog';
import ChatMessageDialogTitle from './components/ChatMessageDialogTitle';
import ChatMessageDialogDescription from './components/ChatMessageDialogDescription';
import ChatMessageDialogConfirmCancelFooter from './components/ChatMessageDialogConfirmCancelFooter';
import { deleteMessage } from '../CustomMessage/Utils/MessageUtils';
import { messageIdToDeleteAtom } from '../../atoms/MessageActionsAtoms';
import { useCallback } from 'react';

const DeleteMessageDialog = ({ sessionChatContainer, trackClickEvent }) => {
    const { client } = useChatClient();
    const [messageIdToDelete, setMessageIdToDelete] = useAtom(messageIdToDeleteAtom);

    const onClose = useCallback(async () => {
        const messageToDelete = (await client.getMessage(messageIdToDelete)).message;
        await trackClickEvent({
            buttonType: 'DELETE_MESSAGE_POP_UP',
            subCategory: 'CANCEL',
            description: {
                message_type: 'TEXT',
                message_id: messageToDelete.id,
                is_pinned: messageToDelete.pinned,
                parent_type: messageToDelete?.parent_id && 'TEXT',
                parent_id: messageToDelete.parent_id,
            },
        });
        setMessageIdToDelete('');
    }, [messageIdToDelete]);

    const onConfirm = useCallback(async () => {
        const messageToDelete = (await client.getMessage(messageIdToDelete)).message;
        await deleteMessage(client, messageIdToDelete);
        await trackClickEvent({
            buttonType: 'DELETE_MESSAGE_POP_UP',
            subCategory: 'DELETE',
            description: {
                message_type: 'TEXT',
                message_id: messageToDelete.id,
                is_pinned: messageToDelete.pinned,
                parent_type: messageToDelete?.parent_id && 'TEXT',
                parent_id: messageToDelete.parent_id,
            },
        });
        setMessageIdToDelete('');
    }, [messageIdToDelete]);

    return (
        <ChatMessageDialog parentElementRef={sessionChatContainer} onClose={onClose}>
            <ChatMessageDialogTitle>You are about to delete this message</ChatMessageDialogTitle>
            <ChatMessageDialogDescription>
                Attendees will see that the message was deleted by the host. Are you sure you want
                to delete this message?
            </ChatMessageDialogDescription>
            <ChatMessageDialogConfirmCancelFooter
                confirmText="Yes, delete"
                onClose={onClose}
                onConfirm={onConfirm}
            />
        </ChatMessageDialog>
    );
};

export default DeleteMessageDialog;
